/* eslint-disable */
import React from 'react';
import { LandigStore } from './components/LandingStore';
import { ApolloContext } from './context';
import './assets/fonts/CustomFonts';

const App: React.FC = () => {
  return (
    <ApolloContext>
      <LandigStore />
    </ApolloContext>
  );
};

export default App;
